/* MediCaptain PDP: variant picking, pack pricing, gallery, add to cart, add-on card */
(function () {
  function money(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var html = (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.textContent;
  }

  function readJson(el) {
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function refreshCart(cartUrl) {
    var drawer = document.getElementById('site-cart-sidebar');
    var form = document.getElementById('AjaxCartForm');
    if (!drawer || !form) { window.location.href = cartUrl; return Promise.resolve(); }
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newForm = doc.getElementById('AjaxCartForm');
        var newSubtotal = doc.getElementById('AjaxCartSubtotal');
        if (!newForm) throw new Error('cart section missing');
        form.innerHTML = newForm.innerHTML;
        if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
        var count = form.querySelector('[data-cart-count]');
        var total = form.querySelector('[data-cart-total]');
        document.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
        document.querySelectorAll('[data-header-cart-total]').forEach(function (el) {
          if (total) el.textContent = total.textContent;
        });
        var subtotal = document.getElementById('AjaxCartSubtotal');
        if (subtotal && newSubtotal) subtotal.innerHTML = newSubtotal.innerHTML;
        form.dispatchEvent(new Event('cart-updated', { bubbles: true }));
        if (typeof drawer.show === 'function') drawer.show();
        else window.location.href = cartUrl;
      })
      .catch(function () { window.location.href = cartUrl; });
  }

  function addToCart(root, variantId, button, errorEl) {
    var addUrl = (root.dataset.cartAddUrl || '/cart/add') + '.js';
    var cartUrl = root.dataset.cartUrl || '/cart';
    if (errorEl) errorEl.textContent = '';
    button.disabled = true;
    button.classList.add('is-loading');
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
          return j;
        });
      })
      .then(function () { return refreshCart(cartUrl); })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message || 'Could not add to cart.';
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.dispatchEvent(new Event('mcp:added'));
      });
  }

  function initAddon(root, getMainColor) {
    var card = root.querySelector('[data-mcp-addon]');
    if (!card) return function () {};
    var data = readJson(card.querySelector('[data-mcp-addon-json]'));
    if (!data || !data.variants.length) return function () {};
    var fmt = root.dataset.moneyFormat;
    var select = card.querySelector('[data-mcp-addon-color]');
    var priceEl = card.querySelector('[data-mcp-addon-price]');
    var button = card.querySelector('[data-mcp-addon-add]');
    var errorEl = card.querySelector('[data-mcp-addon-error]');
    var ci = data.colorIndex;
    var first = data.variants[0];
    var touched = false;

    function pick() {
      var color = select ? select.value : null;
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) {
          if (i === ci && color !== null) return o === color;
          return o === first.options[i];
        });
      })[0];
    }

    function render() {
      var v = pick();
      if (priceEl) priceEl.textContent = v ? money(v.price, fmt) : '';
      button.disabled = !v || !v.available;
      button.textContent = !v || !v.available ? button.dataset.soldOut : button.dataset.label;
    }

    if (select) select.addEventListener('change', function () { touched = true; render(); });
    button.addEventListener('mcp:added', render);
    button.addEventListener('click', function () {
      var v = pick();
      if (v) addToCart(root, v.id, button, errorEl);
    });
    render();

    return function syncColor() {
      if (!select || touched) return;
      var want = (getMainColor() || '').toLowerCase();
      for (var i = 0; i < select.options.length; i++) {
        if (select.options[i].value.toLowerCase() === want) { select.selectedIndex = i; break; }
      }
      render();
    };
  }

  function init(root) {
    var data = readJson(root.querySelector('[data-mcp-product]'));
    if (!data) return;
    var fmt = root.dataset.moneyFormat;
    var ci = data.colorIndex;
    var pi = data.packIndex;
    var idInput = root.querySelector('[data-mcp-id]');
    var button = root.querySelector('[data-mcp-add]');
    var stockEl = root.querySelector('[data-mcp-stock]');
    var errorEl = root.querySelector('[data-mcp-error]');
    var sticky = root.querySelector('[data-mcp-sticky]');
    var stickyBtn = root.querySelector('[data-mcp-sticky-add]');
    var stickyPrice = root.querySelector('[data-mcp-sticky-price]');
    var stickyTitle = root.querySelector('[data-mcp-sticky-variant]');

    var start = data.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || data.variants[0];
    var sel = start.options.slice();

    function find(opts) {
      return data.variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function showMedia(id) {
      var found = false;
      root.querySelectorAll('[data-mcp-slide]').forEach(function (s) {
        if (s.dataset.mediaId === String(id)) found = true;
      });
      if (!found) return;
      root.querySelectorAll('[data-mcp-slide]').forEach(function (s) {
        var on = s.dataset.mediaId === String(id);
        s.hidden = !on;
        if (!on) {
          var vid = s.querySelector('video');
          if (vid) vid.pause();
        }
      });
      root.querySelectorAll('[data-mcp-thumb]').forEach(function (t) {
        t.classList.toggle('is-on', t.dataset.mediaId === String(id));
      });
    }

    var syncAddon = initAddon(root, function () { return ci > -1 ? sel[ci] : ''; });

    function renderPacks() {
      if (pi < 0) return;
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-mcp-pack]'));
      var info = rows.map(function (r) {
        var opts = sel.slice();
        opts[pi] = r.dataset.value;
        var v = find(opts);
        var pairs = parseInt(r.dataset.value, 10) || 1;
        return { row: r, v: v, pairs: pairs, per: v ? v.price / pairs : null };
      });
      var base = info.filter(function (x) { return x.per !== null; })[0];
      var best = null;
      info.forEach(function (x) {
        if (x.per !== null && (!best || x.per < best.per)) best = x;
      });
      info.forEach(function (x) {
        var r = x.row;
        var on = r.dataset.value === sel[pi];
        r.classList.toggle('is-on', on);
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
        r.classList.toggle('is-soldout', !x.v || !x.v.available);
        var price = r.querySelector('[data-mcp-pack-price]');
        var compare = r.querySelector('[data-mcp-pack-compare]');
        var per = r.querySelector('[data-mcp-pack-per]');
        var chip = r.querySelector('[data-mcp-pack-chip]');
        var badge = r.querySelector('[data-mcp-pack-badge]');
        if (price) price.textContent = x.v ? money(x.v.price, fmt) : '';
        if (compare) {
          var show = x.v && x.v.compare > x.v.price;
          compare.textContent = show ? money(x.v.compare, fmt) : '';
          compare.hidden = !show;
        }
        if (per) {
          if (!x.v) per.textContent = r.dataset.unavailable || 'Unavailable';
          else if (!x.v.available) per.textContent = r.dataset.soldOut || 'Sold out';
          else per.textContent = x.pairs > 1 ? money(Math.round(x.per), fmt) + ' ' + (r.dataset.perLabel || 'per pair') : '';
        }
        if (chip) {
          var pct = base && x !== base && x.per !== null ? Math.round((1 - x.per / base.per) * 100) : 0;
          chip.hidden = pct < 5;
          chip.textContent = pct + '% ' + (r.dataset.chipLabel || 'less per pair');
        }
        if (badge) badge.hidden = !(best && x === best && best !== base && rows.length > 1);
      });
    }

    function render(colorChanged) {
      var v = find(sel);
      root.querySelectorAll('[data-mcp-opt]').forEach(function (b) {
        var i = Number(b.dataset.mcpOpt);
        var on = b.dataset.value === sel[i];
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-mcp-opt-label]').forEach(function (el) {
        el.textContent = sel[Number(el.dataset.mcpOptLabel)];
      });
      renderPacks();

      idInput.value = v ? v.id : '';
      var canBuy = !!(v && v.available);
      var label = canBuy ? button.dataset.label + ' | ' + money(v.price, fmt) : (v ? button.dataset.soldOut : button.dataset.unavailable);
      button.disabled = !canBuy;
      button.textContent = label;

      if (stockEl) {
        var msg;
        var state = 'ok';
        if (!canBuy) { msg = stockEl.dataset.soldOut; state = 'out'; }
        else if (v.tracked && v.qty > 0 && v.qty <= 5) { msg = stockEl.dataset.low.replace('[count]', v.qty); state = 'low'; }
        else msg = stockEl.dataset.inStock;
        stockEl.querySelector('[data-mcp-stock-text]').textContent = msg;
        stockEl.dataset.state = state;
      }

      if (stickyBtn) {
        stickyBtn.disabled = !canBuy;
        stickyBtn.textContent = canBuy ? stickyBtn.dataset.label : button.dataset.soldOut;
      }
      if (stickyPrice) stickyPrice.textContent = v ? money(v.price, fmt) : '';
      if (stickyTitle) stickyTitle.textContent = sel.join(' / ');

      if (colorChanged) {
        if (v && v.media) showMedia(v.media);
        syncAddon();
      }
      if (v && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-mcp-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = Number(b.dataset.mcpOpt);
        sel[i] = b.dataset.value;
        render(i === ci);
      });
    });
    root.querySelectorAll('[data-mcp-pack]').forEach(function (r) {
      r.addEventListener('click', function () {
        sel[pi] = r.dataset.value;
        render(false);
      });
    });
    root.querySelectorAll('[data-mcp-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.mediaId); });
    });

    var form = root.querySelector('[data-mcp-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!idInput.value) return;
        addToCart(root, idInput.value, button, errorEl).then(function () { render(false); });
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!idInput.value) return;
        addToCart(root, idInput.value, stickyBtn, errorEl).then(function () { render(false); });
      });
    }
    if (sticky) {
      var ticking = false;
      var syncSticky = function () {
        ticking = false;
        sticky.classList.toggle('is-visible', button.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(syncSticky); }
      }, { passive: true });
      syncSticky();
    }

    render(false);
    syncAddon();
  }

  function boot() {
    document.querySelectorAll('[data-mcp-root]').forEach(function (root) {
      if (root.dataset.mcpReady) return;
      root.dataset.mcpReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
